export class Gtm {
    public startInTicks: number
    public uniqueEventId?: number
    public element?: string

    public constructor(uniqueEventId?: number, element?: string) {
        this.startInTicks = new Date().getTime()
        this.uniqueEventId = uniqueEventId
        this.element = element
    }
}

export class DataLayer {
    public event: string
    public gtm: Gtm
    public user_id: string | null | undefined

    public constructor(event: string, uniqueEventId?: number, element?: string) {
        this.event = event
        this.gtm = new Gtm(uniqueEventId, element)
    }
}
